<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="header">
        <v-app-bar
                flat
                dark
                :fixed="isHomePage"
                class="mobile-header justify-space-around mx-0 header--background"
        >
            <router-link to="/" class="logo-link white--text pl-5 padding-left-0" v-if="!isHomePage" :title="$t('logoTitle')">
                <v-img :src="getMainLogoPath()" width="130px" contain :alt="$t('logoAlt')"></v-img>
            </router-link>
            <span v-else class="logo-link white--text pl-5 padding-left-0">
                <v-img :src="getMainLogoPath()" width="130px" contain :alt="$t('logoAlt')"></v-img>
            </span>
            <app-language text-color="white--text"></app-language>
            <div class="hidden-sm-and-down" :class="visibilityClass" style="min-width: 25%">
                <smart-search rounded use-default-class>
                   <!-- <region-menu :items="regionsLinks" slot="region"></region-menu>-->
                </smart-search>
            </div>
            <div class="hidden-sm-and-down" :class="visibilityClass">
                <currency-selector></currency-selector>
            </div>
            <v-layout class="hidden-md-and-up justify-end pr-0 pr-sm-5" style="min-width: 80px">
                <v-btn icon fab small text @click="showMobileSearch = !showMobileSearch" class="no-propagation">
                    <v-icon class="no-propagation" v-show="showMobileSearchIcon">search</v-icon>
                </v-btn>
            </v-layout>
            <NotLoggedOperations v-if="!isUserLoggedIn"></NotLoggedOperations>
            <header-profile
                    @profile-enter="enterProfile"
                    @logout="logout"
                    class="padding-right-0 pr-5"
                    v-if="isUserLoggedIn"
            ></header-profile>
            <div class="right order-first order-md-last sidebar-nav-btn">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            </div>
        </v-app-bar>
        <v-navigation-drawer
                v-model="drawer"
                fixed
                temporary
        >
            <v-list dense>
                <router-link
                        to="/"
                        class="headline font-weight-bold text-uppercase pa-5 d-flex justify-center"
                >
                    <v-img
                        :src="getMobileLogoPath()"
                        alt="AGROLINK"
                        max-width="70%"
                        max-height="70%"
                    ></v-img>
                </router-link>
                <div v-if="!isUserLoggedIn">
                    <div class="d-flex justify-space-around">
                        <v-btn
                            depressed
                            justify="center"
                            text
                            color="#f5b821"
                            @click="$router.push({name: 'login'})"
                        >{{$t('login')}}</v-btn>
                    </div>
                </div>
                <div v-if="(!isUserLoggedIn || !isSeller)" class="d-flex justify-space-around">
                    <v-btn
                        depressed
                        justify="center"
                        text
                        color="#f5b821"
                        @click="showSellerRegDialog"
                    >
                        {{ $t('sellerRegistration') }}
                    </v-btn>
                </div>
                <v-divider></v-divider>
                <v-card-title class="px-4 py-2 font-weight-bold subtitle-1">{{$t('catalog')}}</v-card-title>
                <v-expansion-panels accordion multiple flat>
                    <v-expansion-panel
                            v-for="item in categoryItems" :key="item.id"
                    >
                        <v-expansion-panel-header
                                class="categoryItems-header pa-0 px-5 menu-hover"
                        >
                            <router-link :to="item.url" color="black">
                                <img
                                    :src="`${getCdnPath()}/icons/${item.icon}-black.svg`"
                                    class="menu-icon"
                                />
                                <span>&nbsp;{{ item.localName }}</span>
                            </router-link>
                            <template v-slot:actions>
                                <v-icon>$expand</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="overflow-y height-300">
                            <div
                                    v-for="sub in item.subCategories" :key="sub.id"
                                    class="pb-2"
                            >
                                <router-link :to="sub.url" class="menu-hover-links">{{ sub.localName }}</router-link>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-action>
                        <v-badge color="teal" overlap :value="comparedCount">
                            <span slot="badge">{{ comparedCount }}</span>
                            <v-img
                                contain
                                :src="comparedIconPaths.comparedPageDrawer"
                                :width="comparedIconSizes.width"
                                :height="comparedIconSizes.height"
                            ></v-img>
                        </v-badge>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/products/compare">{{ $t('compareProducts') }}</router-link>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="isUserLoggedIn">
                    <v-list-item-action>
                        <v-badge color="teal" overlap :value="favoritesCount">
                            <span slot="badge">{{ favoritesCount }}</span>
                            <v-icon>favorite</v-icon>
                        </v-badge>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/profile/favorites">{{ $t('favorites') }}</router-link>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-action>
                        <v-icon>calculate</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/calculator">{{ $t('calculator') }}</router-link>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-action>
                        <v-badge color="teal" overlap :value="noLoginBasketCount">
                            <span slot="badge">{{ noLoginBasketCount }}</span>
                            <v-icon>shopping_cart</v-icon>
                        </v-badge>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/basket">{{ $t('basket') }}</router-link>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title class="d-flex align-center">
                        <div>{{ $t('currency') }}:</div>
                        <currency-selector></currency-selector>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-action>
                        <v-icon>help</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/faq">{{$t('questionsAndAnswers')}}</router-link>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <app-language class="d-flex pa-0 justify-center"></app-language>
            </v-list>
        </v-navigation-drawer>
        <div class="header__search" :style="{position: isHomePage ? 'fixed' : 'absolute'}">
            <v-scale-transition leave-absolute>
                <div v-show="showMobileSearch" class="header--background" style="width: 100%">
                    <smart-search rounded use-default-class @update-search="showMobileSearch = false">
                        <region-menu :items="regionsLinks" slot="region" @update-menu="showMobileSearch = false"></region-menu>
                    </smart-search>
                </div>
            </v-scale-transition>
        </div>
        <categories-menu :class="{'header__categories-menu': isHomePage}"></categories-menu>
        <seller-registration></seller-registration>
    </div>
</template>

<script>
    import AppLanguage from '../../../general/language';
    import AddToBasket from '../../../app-front/mixins/AddToBasket';
    import Auth from '../../../app-front/mixins/Auth';
    import AppVariables from '../../mixins/AppVariables';
    import CategoriesMenu from '../../../app-front/components/categories-menu';
    import CurrencySelector from '../../../app-front/components/currency-selector';
    import Favorites from '../../../app-front/mixins/Favorites';
    import NoLoginBasket from "../../mixins/NoLoginBasket";
    import HeaderProfile from '../header-profile';
    import RegionMenu from '../../../general/geo/link-menu';
    import SmartSearch from '../../../app-front/components/smart-search';
    import TopLogo from '../../../general/top-logo'
    import CategoriesDataMixin from '../../../app-front/mixins/CategoriesData';
    import SellerRegistration from "../dialogs/SellerRegistration";
    import ProductsCompare from '../../mixins/ProductsCompare';
    import ProfileDataProvider from "../../mixins/ProfileDataProvider";
    import NotLoggedOperations from "./NotLoggedOperations"

    import './header.scss'

    export default {
        name: "Header",
        mixins: [
            AppVariables,
            AddToBasket,
            Auth,
            CategoriesDataMixin,
            Favorites,
            NoLoginBasket,
            ProfileDataProvider,
            ProductsCompare
        ],
        components: {
            Auth,
            AppLanguage,
            HeaderProfile,
            RegionMenu,
            SmartSearch,
            TopLogo,
            CategoriesMenu,
            CurrencySelector,
            SellerRegistration,
            NotLoggedOperations,
        },
        data() {
            return {
                drawer: false,
                show: false,
                showMobileRegion: false,
                showMobileSearch: false,
                showMobileSearchIcon: false,
                isScrolled: false,
            }
        },
        computed: {
            regionsLinks() {
                return this.$store.state.geo.regions;
            },
            isHomePage() {
                return this.$route.name === 'home';
            },
            visibilityClass() {
                return this.isVisibleElements ? 'header--visibility-visible' : 'header--visibility-hidden'
            },
            isVisibleElements() {
                return !this.isHomePage || (this.isHomePage && this.isScrolled);
            },
        },
        methods: {
            enterProfile() {
                this.$emit('enterProfile');
            },
            logout() {
                this.$emit('logout');
            },
            scrollHandler() {
                this.isScrolled = window.scrollY > 500;
            },
        },
        created(){
            if(this.isProfileEmpty()) {
                this.setProfileData();
            }
        },
        mounted() {
            window.addEventListener('scroll', this.scrollHandler);
            document.body.addEventListener('click',(e) => {
                if(e.target.closest('.smart-search')) return false;

                if (!e.target.classList.contains('no-propagation')) {
                    this.showMobileSearch = false;
                }
            });
            setTimeout(() => {
                this.showMobileSearchIcon = true;
            }, 1000);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scrollHandler);
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../../sass/_variables.scss";
    a.v-btn {
        color:#fff;
    }
    svg.logo {
        max-width: $svgLogoWidth;
        height: 100%;
    }

    .logo-link {
        font-size: 26px;
        font-weight: 700;

    }

    .menu-icon {
        width: 24px;
        height: 24px;
    }
</style>

